<template>
  <div
    id="code_pro"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div class="inmenuspin animate__animated animate__bounceIn">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct px-3">
        <div class="menuhead mb-2">
          <i class="fal fa-gem tablinks"></i> กงล้อนำชัย
        </div>
        <div class="depositimg">
          <!-- <img src="./../../assets/moneyback.png" /> -->
          <button
            @click="multiplierSpin"
            :disabled="!can_creditspin"
            class="bg-info btn-multiplier"
          ></button>
          <FortuneWheel
            class="wheel-multiplier"
            :prizes="prizes"
            :useWeight="true"
            :angleBase="10"
            type="image"
            @rotateStart="onImageRotateStartMultiplier"
            @rotateEnd="onRotateEnd"
          >
            <img
              slot="wheel"
              src="@/assets/spin/greenwhSpin.png"
              class="img-wheel-multiplier"
            />
            <img
              slot="button"
              id="multiplier_spinbtn"
              src="@/assets/spin/randomwh1.png"
              class="img-btn-multiplier"
            />
          </FortuneWheel>
          <div class="spin-click-multiplier">x{{ spinData.multiplier }}</div>
          <div>
            <img
              src="@/assets/spin/centerframe.png"
              alt=""
              class="img-detail-center"
            />
          </div>
          <!-- <hr /> -->
          <button
            @click="creditSpin"
            :disabled="!can_creditspin"
            class="bg-info btn-credit"
          ></button>
          <FortuneWheel
            class="wheel-credit"
            :prizes="prizes2"
            :angleBase="10"
            type="image"
            :useWeight="true"
            @rotateStart="onImageRotateStart"
            @rotateEnd="onRotateEndCredit"
          >
            <img
              slot="wheel"
              src="@/assets/spin/greenwh.png"
              class="img-wheel-credit"
            />
            <img
              slot="button"
              id="credit_spinbtn"
              src="@/assets/spin/random_wheel2.png"
              class="img-btn-credit"
            />
          </FortuneWheel>
        </div>
        <div class="spin-click-credit text-center m-2">
          {{ spinData.credit ?? 0 }}฿
        </div>
        <div class="animate__animated animate__flipInX">
          <!-- <div class="form-group mb-4">
            <input
              type="text"
              id="code_input"
              class="form-control text-center p-0 py-2"
              placeholder="ใส่ Code กิจกรรม"
              style="font-size: 1.2em !important; font-weight: bold"
            />
          </div> -->
          <div class="row m-2">
            <div class="col-12 d-flex justify-content-center">
              <button
                type="button"
                id="btn_claim"
                class="loginbtn my-0"
                @click="debounceSclaimSpin"
                :disabled="isActionInProgress"
                style="width: 200px"
              >
                <img
                  src="./../../assets/moneyback.png"
                  width="30px"
                  height="30px"
                />
                <span> รับรางวัล </span>
              </button>
            </div>
          </div>
          <div class="spin-token">{{ token }}</div>
          <!-- <div class="text-center">
            แหล่งหา Code กิจกรรม
            <a target="_blank" style="color: gold"><u>รายละเอียด</u></a>
          </div> -->
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import FortuneWheel from "vue-fortune-wheel";
import "vue-fortune-wheel/lib/vue-fortune-wheel.css";
import { HTTP } from "@/services/http-common";

export default {
  name: "codemodal-component",
  components: {
    FortuneWheel,
  },
  data() {
    return {
      isActionInProgress: false,
      debounceTimeout: null,
      showModal: false,
      cavansVerify: true, // Whether the turntable in canvas mode is enabled for verification
      canvasOptions: {
        borderWidth: 6,
        borderColor: "#584b43",
        btnText: "หมุน",
      },
      // canvasOptions2: {
      //   borderWidth: 6,
      //   borderColor: "#584b43",
      //   btnText: "5฿",
      // },
      canvasVerify: true,
      prizes: [
        {
          id: 1,
          name: "",
          value: "ยินดีด้วยคุณได้ X1",
          bgColor: "#22b73b",
          color: "#ffffff",
          probability: 0,
          weight: 0,
        },
        {
          id: 2,
          name: "",
          value: "ยินดีด้วยคุณได้ X3",
          bgColor: "#22b73b",
          color: "#ffffff",
          probability: 0,
          weight: 0,
        },
        {
          id: 3,
          name: "",
          value: "ยินดีด้วยคุณได้ X10",
          bgColor: "#22b73b",
          color: "#ffffff",
          probability: 0,
          weight: 0,
        },
        {
          id: 4,
          name: "",
          value: "ยินดีด้วยคุณได้ X25",
          bgColor: "#22b73b",
          color: "#ffffff",
          probability: 0,
          weight: 0,
        },
        {
          id: 5,
          name: "",
          value: "ยินดีด้วยคุณได้ X50",
          bgColor: "#423f3f",
          color: "#ffffff",
          probability: 0,
          weight: 0,
        },
        {
          id: 6,
          name: "",
          value: "",
          probability: 0,
          weight: 0,
        },
        {
          id: 7,
          name: "",
          value: "",
          probability: 0,
          weight: 0,
        },
        {
          id: 8,
          name: "",
          value: "",
          probability: 0,
          weight: 0,
        },
      ],
      prizes2: [
        {
          id: 1,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 2,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 3,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 4,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 5,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 60,
        },
        {
          id: 6,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 7,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
        {
          id: 8,
          name: "",
          value: "ยินดีด้วย",
          probability: 0,
          weight: 0,
        },
      ],
      multiplierData: [],
      credit: "0",
      multiplier: "1",
      reward: "",
      can_creditspin: true,
      reward_credit: "",
      token: 0,
    };
  },
  methods: {
    fetchSpin() {
      // this.resetSpin();
      // this.resetCredit();
      // this.canvasVerify = true;
      console.log (this.showModal,this.spinX,this.token);
      HTTP.get(`game/spin`)
        .then((response) => {
          if (response.data.status) {
            this.spinData = response.data.data;
            this.spinX = response.data.data.multiplier;
            this.credit = response.data.data.credit;
            this.token = response.data.token;
            if (response.data.token == "0") {
              this.$toast.error("สิทธ์คงเหลือ 0");
              // this.showModal = false;
            } else {
              this.showModal = true;
            }
          } else {
            this.token = response.data.token;
            this.$toast.error(
              response.data.msg != undefined
                ? response.data.msg
                : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            );
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    multiplierSpin() {
      // document.getElementById("btn_multiplier").disabled = true;
      this.can_creditspin = false;
      this.resetSpin();
      HTTP.get(`game/spin?multiplier`)
        .then((response) => {
          if (response.data.status) {
            this.spinX = response.data.data.multiplier;
            this.reward = response.data.data.reward;
            this.reward_credit = response.data.data.reward_credit;
            setTimeout(() => {
              this.spinData = response.data.data;
            }, 6000);
            // this.onCanvasRotateStart(rotate);
            this.checkMultiplier(response.data.data.reward);
            setTimeout(() => {
              document.getElementById("multiplier_spinbtn").click();
            }, 300);
          } else {
            this.$toast.error(
              response.data.msg != undefined
                ? response.data.msg
                : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            );
            this.can_creditspin = true;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    debounceSclaimSpin() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.claimSpin();
    }, 1500); // Adjust the delay as needed
  },
    claimSpin() {
      document.getElementById("btn_claim").disabled = true;
      HTTP.get(`game/spin?claim`)
        .then((response) => {
          if (response.data.status) {
            // this.$toast.success(
            //   `Claim สำเร็จ คุณได้รับ ${response.data.data.reward_credit} เครดิต`
            // );
            this.spinData = response.data.data;
            this.canvasVerify = false;
            //   // this.spinData = response.data.data;
            // } else {
            //   this.$toast.error(
            //     response.data.msg != undefined
            //       ? response.data.msg
            //       : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            //   );
            let homeCont = this.$refs.homeCont;
            let loader = this.$loading.show(
              {
                container: homeCont,
                loader: "Dots",
                color: "red",
                opacity: 0.5,
                backgroundColor: "#000000",
              },
              {
                // Pass slots by their names
                default: `ยินดีด้วย คุณได้รับรางวัล ${
                  this.spinData.reward_credit ?? 0
                } เครดิต`,
              }
            );
            setTimeout(() => {
              loader.hide();
              this.showModal = false;
            }, 3000);
          } else {
            this.$toast.error(
              response.data.msg != undefined
                ? response.data.msg
                : "ไม่สามารถ Claim ได้ กรุณาลองใหม่"
            );
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.response.data.msg != undefined
              ? err.response.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        })
        .finally(() => {
          this.isLoading = false;
          this.isActionInProgress = false;
        })
        .then(() => {
          document.getElementById("btn_claim").disabled = false;
        });
    },
    checkMultiplier(multiplier) {
      if (multiplier) {
        this.prizes[0].weight = 0;
        this.prizes[1].weight = 20;
        this.prizes[2].weight = 20;
        this.prizes[3].weight = 0;
        this.prizes[4].weight = 20;
        this.prizes[5].weight = 20;
        this.prizes[6].weight = 20;
        this.prizes[7].weight = 0;
      } else {
        this.prizes[0].weight = 50;
        this.prizes[1].weight = 0;
        this.prizes[2].weight = 0;
        this.prizes[3].weight = 0;
        this.prizes[4].weight = 0;
        this.prizes[5].weight = 0;
        this.prizes[6].weight = 0;
        this.prizes[7].weight = 50;
      }
    },
    resetSpin() {
      this.prizes[0].weight = 0;
      this.prizes[1].weight = 0;
      this.prizes[2].weight = 0;
      this.prizes[3].weight = 0;
      this.prizes[4].weight = 0;
      this.prizes[5].weight = 0;
      this.prizes[6].weight = 0;
      this.prizes[7].weight = 0;
    },
    show() {
      // this.showModal = true;
      this.fetchSpin();
    },
    hide() {
      this.showModal = false;
      this.$emit("OpenMenuModalProp", true);
    },
    creditSpin() {
      this.resetCredit();
      this.can_creditspin = false;
      HTTP.get(`game/spin?credit`)
        .then((response) => {
          if (response.data.status) {
            this.credit = response.data.data.credit;
            this.reward_credit = response.data.data.reward_credit;
            this.reward = response.data.data.reward;
            setTimeout(() => {
              this.spinData = response.data.data;
            }, 6000);
            this.checkCredit(response.data.data.reward);
            setTimeout(() => {
              document.getElementById("credit_spinbtn").click();
            }, 300);
          } else {
            this.can_creditspin = true;
            this.$toast.error(
              response.data.msg != undefined
                ? response.data.msg
                : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            );
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    checkCredit(credit) {
      if (credit) {
        this.prizes2[0].weight = 0;
        this.prizes2[1].weight = 20;
        this.prizes2[2].weight = 20;
        this.prizes2[3].weight = 0;
        this.prizes2[4].weight = 20;
        this.prizes2[5].weight = 20;
        this.prizes2[6].weight = 20;
        this.prizes2[7].weight = 0;
      } else {
        this.prizes2[0].weight = 50;
        this.prizes2[1].weight = 0;
        this.prizes2[2].weight = 0;
        this.prizes2[3].weight = 0;
        this.prizes2[4].weight = 0;
        this.prizes2[5].weight = 0;
        this.prizes2[6].weight = 0;
        this.prizes2[7].weight = 50;
      }
    },
    onImageRotateStart() {
      console.log("onRotateStart");
    },
    onImageRotateStartMultiplier() {
      console.log("onRotateStartX");
    },
    onRotateEndCredit() {
      if (!this.reward) {
        // this.$toast.success(
        //   `ยินดีด้วย คุณได้รับ ${this.spinData.reward_credit} เครดิต`
        // );
        // this.$toast.error(
        //   `การพนันล้มเหลว! คุณได้รับ ${this.spinData.reward_credit} เครดิต`
        // );
        let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show(
          {
            container: homeCont,
            loader: "Dots",
            color: "red",
            opacity: 0.5,
            backgroundColor: "#000000",
          },
          {
            // Pass slots by their names
            default: `การพนันล้มเหลว! กรุณาลองใหม่อีกครั้ง`,
          }
        );
        setTimeout(() => {
          loader.hide();
          // this.showModal = false;
          this.fetchSpin();
        }, 2500);
      }
      this.can_creditspin = true;
    },
    resetCredit() {
      this.prizes2[0].weight = 0;
      this.prizes2[1].weight = 0;
      this.prizes2[2].weight = 0;
      this.prizes2[3].weight = 0;
      this.prizes2[4].weight = 0;
      this.prizes2[5].weight = 0;
      this.prizes2[6].weight = 0;
      this.prizes2[7].weight = 0;
    },
    onCanvasRotateStart(rotate) {
      if (this.canvasVerify) {
        const verified = true; // true: the test passed the verification, false: the test failed the verification
        this.DoServiceVerify(verified, 100).then((verifiedRes) => {
          if (verifiedRes) {
            this.multiplierSpin();
            setTimeout(() => {
              rotate(); // Call the callback, start spinning
            }, 300);
            this.canvasVerify = false; // Turn off verification mode
          } else {
            alert("Failed verification");
          }
        });
      }
    },
    // onCanvasRotateStartCredit(rotate) {
    //   if (this.canvasVerify) {
    //     const verified = true; // true: the test passed the verification, false: the test failed the verification
    //     this.DoServiceVerify(verified, 100).then((verifiedRes) => {
    //       if (verifiedRes) {
    //         this.creditSpin();
    //         setTimeout(() => {
    //           rotate(); // Call the callback, start spinning
    //         }, 300);
    //         // console.log(this.prizes2);
    //         this.canvasVerify = false; // Turn off verification mode
    //       } else {
    //         alert("Failed verification");
    //       }
    //     });
    //   }
    // },
    onRotateEnd() {
      // this.resetSpin();
      // document.getElementById("btn_credit").disabled = false;
      // document.getElementById("btn_multiplier").disabled = false;
      if (!this.reward) {
        // this.$toast.success(
        //   `ยินดีด้วย คุณได้ ${this.spinData.reward_credit} เครดิต`
        // );
        let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show(
          {
            container: homeCont,
            loader: "Dots",
            color: "red",
            opacity: 0.5,
            backgroundColor: "#000000",
          },
          {
            // Pass slots by their names
            default: `การพนันล้มเหลว! กรุณาลองใหม่อีกครั้ง`,
          }
        );

        // this.$toast.error(
        //   `ยินดีด้วย คุณได้รับ ${this.spinData.reward_credit} เครดิต`
        // );
        setTimeout(() => {
          loader.hide();
          // this.showModal = false;
          this.fetchSpin();
        }, 2500);
      }
      this.can_creditspin = true;
    },
    // Simulate the request back-end interface, verified: whether to pass the verification, duration: delay time
    DoServiceVerify(verified, duration) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(verified);
        }, duration);
      });
    },
    // rateSpin() {
    //   if (this.spinData) {
    //     if (this.spinData.multiplier == "1") {
    //       return 100;
    //     } else if (this.spinData.multiplier == "3") {
    //       return 100;
    //     } else if (this.spinData.multiplier == "10") {
    //       return 100;
    //     } else if (this.spinData.multiplier == "25") {
    //       return 100;
    //     } else if (this.spinData.multiplier == "50") {
    //       return 100;
    //     }
    //   } else {
    //     return 1;
    //   }
    // },
  },
};
</script>

<style></style>
